import { useCountdown } from "@/hooks/useCountdown";
import { useAbVariant } from "@/hooks/useAbVariant";

export default function StickyMobileCTA() {
  const { formatted } = useCountdown();
  const { copy, variant } = useAbVariant();
  return (
    <div
      data-testid="sticky-cta"
      className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-[#1A1A1A] text-[#F6F1E8] px-5 py-3 flex items-center justify-between gap-3 border-t border-black/20"
    >
      <div>
        <p className="eyebrow opacity-70 text-[0.6rem]">Offer closes in</p>
        <p className="font-serif-display italic text-base tabular-nums">{formatted}</p>
      </div>
      <a
        href="#apply"
        data-testid="sticky-cta-button"
        data-cta-variant={variant}
        className="bg-[#F6F1E8] text-[#1A1A1A] px-4 py-3 eyebrow"
      >
        {copy.short} →
      </a>
    </div>
  );
}
